import React from 'react';
import { AlertCircle, Frown, RefreshCw } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainPointsSection() {
  const pains = [{
    icon: AlertCircle,
    title: 'Dinero perdido',
    description: 'Shampoos, peines y tratamientos que prometen y no resuelven el origen.'
  }, {
    icon: Frown,
    title: 'Estrés y culpa',
    description: 'La sensación de que vuelve justo cuando por fin respirabas.'
  }, {
    icon: RefreshCw,
    title: 'Reinfestación',
    description: 'El verdadero problema: no basta con tratar el cabello una sola vez.'
  }];
  return <section className="py-20 bg-white" data-id="element-127">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
        <div className="text-center mb-16" data-id="element-129">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1e4d7b] mb-4" data-id="element-130">
            Si ya lo intentaste todo… <br className="hidden md:block" data-id="element-131" />
            aquí está por qué no funcionó.
          </h2>
          <div className="w-24 h-1 bg-[#4a90c2] mx-auto rounded-full" data-id="element-132"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-133">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#e8f4fc]/50 p-8 rounded-xl border border-[#e8f4fc] hover:border-[#4a90c2]/30 transition-colors" data-id="element-134">
              <div className="w-14 h-14 bg-[#1e4d7b]/10 rounded-full flex items-center justify-center mb-6 mx-auto" data-id="element-135">
                <pain.icon className="h-7 w-7 text-[#1e4d7b]" data-id="element-136" />
              </div>
              <h3 className="text-xl font-bold text-[#1e4d7b] mb-3 text-center" data-id="element-137">
                {pain.title}
              </h3>
              <p className="text-gray-600 text-center leading-relaxed" data-id="element-138">
                {pain.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}